import RecordAttendanceDrawerForm from '../RecordAttendanceDrawerForm';
import useRecordAttendanceDrawerSteps, { UseRecordAttendanceDrawerSteps } from './vm';

export enum Steps {
  CLASS_SELECTION,
}

export interface StepsProps extends UseRecordAttendanceDrawerSteps {
  currentStep: Steps;
}

const RecordAttendanceDrawerSteps = ({ currentStep, ...vmProps }: StepsProps) => {
  const { handleNext } = useRecordAttendanceDrawerSteps(vmProps);

  switch (currentStep) {
    case Steps.CLASS_SELECTION:
      return <RecordAttendanceDrawerForm onNext={handleNext} />;
    default:
      return null;
  }
};
export default RecordAttendanceDrawerSteps;
